import { useModoConsultaEvaluacion } from '../../../../hooks/useModoConsultaEvaluacion';
import React, { useState, useContext } from 'react';
import { AppContext } from '../../../../Context';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../../../../firebase/firebase';
import { Form, Button } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { lectura } from '../../../../config/m10Ejercicio6Contenido';

const preguntas = [
    { id: 'analogia1', etiqueta: 'Mal es a peor como:', opciones: ['Premio es a triunfo', 'Erosión es a tierra', 'Río es a agua', 'Enfermo es a grave'] },
    { id: 'analogia2', etiqueta: 'Desigualdad es a pobreza como:', opciones: ['Guerra es a conflicto', 'Riqueza es a dinero', 'Erosión es a tala de árboles'] },
    { id: 'analogia3', etiqueta: 'Escasez es a pobreza como:', opciones: ['Abundancia es a dinero', 'Desnutrición es a alimentación', 'Desarrollo es a riqueza'] },
    { id: 'analogia4', etiqueta: 'Colapso es a grave como:', opciones: ['Grande es a enorme', 'Triste es a alegre', 'Todo es a nada'] },
];

const M10_Ejercicio6 = ({ cerrarModal }) => {
    const { currentUser } = useContext(AppContext);
    const modoConsulta = useModoConsultaEvaluacion();
    const [respuestas, setRespuestas] = useState(() => Object.fromEntries(preguntas.map(({ id }) => [id, ''])));
    const [enviando, setEnviando] = useState(false);

    const enviarResultados = async (event) => {
        event.preventDefault();
        if (modoConsulta) { cerrarModal?.(); return; }

        if (enviando) return;
        if (!preguntas.every(({ id }) => respuestas[id].trim() !== '')) {
            await Swal.fire({ icon: 'warning', title: 'Campos incompletos', text: 'Responde las cuatro analogías antes de enviar la evaluación.', confirmButtonText: 'Aceptar' });
            return;
        }
        setEnviando(true);
        try {
            await addDoc(collection(db, 'evaluaciones'), {
                userId: currentUser.uid,
                nombre: 'Ejercicio de Asociación - Ejercicio 6',
                nivel: 'Intermedio',
                modulo: '10',
                createdAt: new Date(),
                tipo: 'Selección múltiple',
                respuestas,
            });
            const result = await Swal.fire({ title: '¡Evaluación enviada!', text: 'Tus respuestas se guardaron correctamente.', icon: 'success', confirmButtonText: 'Excelente' });
            if (result.isConfirmed) cerrarModal();
        } catch (error) {
            console.error('Error al enviar las respuestas: ', error);
            await Swal.fire({ icon: 'error', title: 'No se pudo enviar la evaluación', text: 'Tus respuestas no se guardaron. Verifica tu conexión e inténtalo nuevamente.', confirmButtonText: 'Aceptar' });
        } finally {
            setEnviando(false);
        }
    };

    return (
        <div className="container mt-4">
            <h2>Ejercicio 6: De asociación</h2>
            <p>La asociación permite comprender al establecer relaciones entre el mensaje que interpretamos y lo que ya conocemos.</p>
            <p>Las analogías comparan la relación entre dos conceptos con la de otros que guardan una relación semejante: por composición, tamaño, clasificación, similitud, diferencias, pertenencia, oposición, función, causa, efecto o cualidad.</p>
            <p>Lee el texto y responde según tu criterio por asociación. Detecta primero el tipo de relación entre los conceptos de la primera frase y luego busca la relación análoga.</p>
            <section aria-labelledby="m10e6-lectura">
                <h3 id="m10e6-lectura">Lectura: Desarrollo de la pobreza</h3>
                {lectura.map((parrafo, index) => <p key={index}>{parrafo}</p>)}
            </section>
            <Form onSubmit={enviarResultados}>
                <h3>Responde según tu criterio por asociación</h3>
                {preguntas.map(({ id, etiqueta, opciones }, index) => (
                    <fieldset key={id} className="border rounded p-3 mb-3" disabled={enviando}>
                        <legend className="fs-5">{index + 1}. {etiqueta}</legend>
                        {opciones.map((opcion, opcionIndex) => (
                            <Form.Check key={opcion} id={`m10e6-${id}-${opcionIndex}`} type="radio" name={id}
                                label={`${String.fromCharCode(97 + opcionIndex)}) ${opcion}`} value={opcion}
                                checked={respuestas[id] === opcion}
                                onChange={({ target }) => setRespuestas(prev => ({ ...prev, [target.name]: target.value }))}
                            />
                        ))}
                    </fieldset>
                ))}
                <Button type="submit" disabled={enviando}>{enviando ? 'Enviando…' : 'Enviar Resultados'}</Button>
            </Form>
        </div>
    );
};

export default M10_Ejercicio6;
